import { jsxs as i, jsx as e } from "react/jsx-runtime";

import n from "../hooks/useGlobals.js";

import t from "@ui-components-3/icons/lib/solid/AnglesLeft";

import o from "@ui-components-3/icons/lib/solid/AnglesRight";

import l from "@ui-components-3/icons/lib/solid/AngleLeft";

import r from "@ui-components-3/icons/lib/solid/AngleRight";

import { addYears as a, endOfYear as s, addMonths as m, endOfMonth as d, startOfMonth as c, startOfYear as p } from "../utils/index.js";

const h = () => {
    const {model: h, components: {MonthYearLabel: f, MonthYearNavigationButton: u}} = n();
    return i("div", {
        className: "flex items-center justify-between",
        children: [ i("div", {
            className: "gap-xxs inline-flex",
            children: [ e(u, {
                fn: a,
                limitFn: s,
                step: -1,
                "aria-label": "previous year",
                children: e(t, {
                    "aria-hidden": "true"
                })
            }), e(u, {
                fn: m,
                limitFn: d,
                step: -1,
                "aria-label": "previous month",
                children: e(l, {
                    "aria-hidden": "true"
                })
            }) ]
        }), e("div", {
            "aria-live": "polite",
            id: h.ids.monthYear,
            children: e(f, {})
        }), i("div", {
            className: "gap-xxs inline-flex",
            children: [ e(u, {
                step: 1,
                fn: m,
                limitFn: c,
                "aria-label": "next month",
                children: e(r, {
                    "aria-hidden": "true"
                })
            }), e(u, {
                step: 1,
                fn: a,
                limitFn: p,
                "aria-label": "next year",
                children: e(o, {
                    "aria-hidden": "true"
                })
            }) ]
        }) ]
    });
};

export { h as default };
//# sourceMappingURL=MonthYear.js.map
